module.exports = __webpack_public_path__ + "img/google-play.40b90826.svg";